import "../JSONTools/JSONformatter.css";
import ToolHeader from "../../Components/ToolHeader";
import { Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import FormatterPanel from "../../HomePage/FormatterPanel";
import { InputHeaderButtons } from "../JSONTools/JSONToolsHeaderButtons";
import { XmlDiffAPI } from "../../Services/APIService";
import { exampleXML } from "../../Services/Tools";

function XMLDifference() {
    const navigate = useNavigate();
    const location = useLocation();

    const [baseXml, setBaseXml] = useState("");
    const [inputs, setInputs] = useState([""]);

    const toolFav = { toolName: "XML Diff", Iconpath: "/GitDiffRaw.svg" };

    

    useEffect(() => {
        if (location.state?.baseXml && location.state?.inputs) {
            setBaseXml(location.state.baseXml);
            setInputs(location.state.inputs);
        }
    }, [location.state]);


    

    const addInput = () => {
        if (inputs.length >= 3) return;
        setInputs([...inputs, ""]);
    };

    const removeInput = (index) => {
        if (inputs.length === 1) return; // prevent removing last one
        const updated = inputs.filter((_, i) => i !== index);
        setInputs(updated);
    };

    const updateInput = (index, value) => {
        const updated = [...inputs];
        updated[index] = value;
        setInputs(updated);
    };


    const pasteExample = (type, index) => {
        const example = exampleXML;

        if (type === "base") setBaseXml(example);
        else updateInput(index, example);
    };

    const computeDiff = async () => {
        if (!baseXml.trim() || inputs.length === 0) return;

        try {
            const payload = {
                baseXml: baseXml,
                compareWith: inputs.filter(i => i!== "" && i.trim())
            };

            const validInputs= inputs.filter(i => i!== "");
            const response = await XmlDiffAPI(payload);
            const apiData = response?.data;

            if (!apiData) return;

            navigate("/xml-diff-view", {
                state: {
                    baseXml: baseXml,
                    inputs,
                    validInputs,
                    comparisons: apiData.comparisons || [],
                }
            });
        } catch (error) {
            console.error("Error:", error);
        }
    };

    return (
        <Col className="json-multi-diff-page">
            {/* HEADER */}
            <ToolHeader title="XML Diff" description="Compare a base XML with multiple XML inputs" toolFav={toolFav} />

            {/* BASE XML */}
            <Row className="Formatter">
                <FormatterPanel
                    title="Base XML"
                    value={baseXml}
                    onChange={(e) => setBaseXml(e.target.value)}
                    placeholder="Paste base XML here..."
                    lineCount={baseXml!== "" ?baseXml.split("\n").length:0}
                    panelStyle={{ width: "100%", height: "250px" }}
                    headerButtons={
                        <InputHeaderButtons
                            primaryLabel="Example"
                            onPrimary={() => pasteExample("base")}
                            onClear={() => setBaseXml("")}
                            onImport={(file) => setBaseXml(file)}
                        />
                    }
                    footerLeft={`Characters : ${baseXml.replaceAll(" ", "").length}`}
                    footerRight={`Size : ${new Blob([baseXml]).size} B`}
                />
            </Row>

            {/* âœ… GRID INPUTS */}
            <Row
                className="multi-input-grid"
                style={{
                    gridTemplateColumns: `repeat(${inputs.length}, 1fr)`
                }}
            >
                {inputs.map((input, index) => (
                    <div key={index} className="grid-item">
                        <FormatterPanel
                            title={`Text ${index + 1}`}
                            value={input}
                            onChange={(e) => updateInput(index, e.target.value)}
                            placeholder="Paste text here..."
                            lineCount={input!== "" ?input.split("\n").length:0}
                            panelStyle={{ height: "250px", width: "inherit" }}
                            headerButtons={
                                <InputHeaderButtons
                                    primaryLabel="Example"
                                    onPrimary={() => pasteExample("input", index)}
                                    onClear={() => updateInput(index, "")}
                                    onImport={(file) => updateInput(index, file)}
                                    accept=".txt"
                                    onRemove={() => removeInput(index)}
                                    showRemove={inputs.length > 1}
                                />
                            }
                            footerLeft={`Characters : ${input.replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([input]).size} B`}
                        />
                    </div>
                ))}
            </Row>

            <Row>
            {inputs.length < 3 && <Col className="add-json-btn" onClick={addInput}>
                + Add XML to compare
            </Col>}
            </Row>

            {/* BOTTOM BAR */}
            
            <Row className="bottom-bar">
                <Col>
                <span>
                    Comparing Base XML with {inputs.filter(i => i.trim()).length} input
                </span>
                </Col>
                <Col>
                <button className="compare-btn" onClick={computeDiff}>
                    Compare
                </button>
                </Col>
            </Row>
             
        </Col>
    );
}

export default XMLDifference;
